import React from 'react';


const Privacy = () => {
	return (
		<div className="container">
			  <h2>
			    <strong>Terms and Conditions</strong>
			  </h2>
			  <p>Welcome to ecoplug!</p>
			  <section className="terms-banner">
			    <div className="container">
			      <div className="terms-banner--innner">
			        <h1>Terms of Service</h1>
			        <div className="terms-banner--content">
			          <p>
			            Please read these Terms of Service carefully as they contain
			            important information about your legal rights, remedies and
			            obligations. By accessing or using our website, www.ecoplug.in and
			            our services, you agree to comply with and be bound by these Terms
			            of Service.
			          </p>
			        </div>
			        <div className="terms-banner--content">
			          <p>
			            These Terms of Service ("Terms") constitute a legally binding
			            agreement ("Agreement") between you and EcoPlug (the contracting
			            entity being “__sharify services private limited; primarily having
			            its office at C/O Kh. 147 ,Rath Nagar, Vijay Mandir Road , Alwar
			            301001 Rajasthan ,BHARAT , which governs your access to and use of
			            our Website including our mobile, tablet and other smart device
			            applications and all associated services, any updates and up
			            gradation of the same (collectively, "Services"). The website, the
			            applications and the Services are hereinafter collectively called
			            the “Website”.
			          </p>
			        </div>
			        <div className="terms-banner--content">
			          <p>
			            Our collection and use of personal information in connection with
			            your access to and use of the Website is described in our Privacy
			            Policy.
			          </p>
			        </div>
			        <div className="terms-banner--content">
			          <ol>
			            <li>
			              <p>
			                The Website makes available information with respect to our
			                business which inter-alia includes the information regarding the
			                locations where our charging stations for EV vehicles are
			                situated alongwith collaborations, for purposes of providing
			                distributorship of the said EV chargers for the same to be
			                installed in various parts of the country. The website also
			                provides a cloud-based eco- system to improve the EV charging
			                network of EcoPlug. In addition, the Website provides the
			                facility to make payment towards the services that may be booked
			                and utilized by the clients/customers of EcoPlug.
			              </p>
			            </li>
			            <li>
			              <p>
			                To promote the Website other member content may be displayed on
			                other websites, in applications, within emails, and in online
			                and offline advertisements. The Website may contain links to
			                third-party websites or resources (“Third-Party Services”). Such
			                Third-Party Services may be subject to different terms and
			                conditions and privacy practices. EcoPlug is not responsible or
			                liable for the availability or accuracy of such Third-Party
			                Services, or the content, or services available from such
			                Third-Party Services. Links to such Third-Party Services are not
			                an endorsement by EcoPlug of such Third-Party Services.
			              </p>
			            </li>
			            <li>
			              <p>
			                Due to the nature of the Internet, EcoPlug cannot guarantee the
			                continuous and uninterrupted availability and accessibility of
			                the Website. EcoPlug may restrict the availability of the
			                Website or certain areas or features thereof, if this is
			                necessary in view of capacity limits, the security or integrity
			                of our servers, or[{"{"}
			                {"{"}type{"}"}
			                {"}"} Annotation] to carry out maintenance measures that ensure
			                the proper or improved functioning of the Website.EcoPlug may
			                improve, enhance and modify the Website and introduce new
			                services from time to time.
			              </p>
			            </li>
			            <li>
			              <p>
			                EcoPlug may make access to and use of the Website, or certain
			                areas or features of the Website, subject to certain conditions
			                or requirements, such as completing a verification process,
			                linked to your mobile phone or any other verification processes.
			              </p>
			            </li>
			            <li>
			              <p>
			                User verification on the Internet is difficult and we do not
			                assume any responsibility for the confirmation of a user’s
			                identity.
			              </p>
			            </li>
			            <li>
			              <p>
			                The access to or use of certain areas and features, the Website
			                may be subject to separate policies, standards or guidelines, or
			                may require that you accept additional terms and conditions. If
			                there is a conflict between these Terms and terms and conditions
			                applicable to a specific area or feature of the Website, the
			                latter terms and conditions will take precedence with respect to
			                your access to or use of that area or feature, unless specified
			                otherwise.
			              </p>
			            </li>
			            <li>
			              <p>
			                EcoPlug reserves the right to modify these Terms at any time in
			                accordance with this provision. If we make changes to these
			                Terms, we will post the revised Terms on the Website and update
			                the “Last Updated” date at the top of these Terms. You
			                understand and agree that your continued access to or use of the
			                Website will constitute acceptance of the revised Terms.
			              </p>
			            </li>
			            <li>
			              <p>
			                As a host or a distributor, upon visiting the website, if you
			                wish to register yourself with EcoPlug, separate terms and
			                conditions shall apply when such provision for registration, for
			                either becoming a host or for getting the distributorship are
			                provided on the website.
			              </p>
			            </li>
			            <li>
			              <p>
			                As and when an account is created by you, you are responsible
			                for maintaining the confidentiality and security of your User
			                Account credentials and may not disclose your credentials to any
			                third party. You are liable for any and all activities conducted
			                through your User Account. All payments received pursuant to the
			                use of the User Account shall be deemed to have been paid by the
			                you shall be considered as a genuine consideration and EcoPlug
			                shall not be responsible or liable for any refunds due to any
			                fraudulent charges.
			              </p>
			            </li>
			            <li>
			              <p>
			                You acknowledge and agree that the Website and the content
			                available on the Website (“EcoPlug”), including all ssociated
			                intellectual property rights, are the exclusive property of
			                EcoPlug. You will not remove, alter or obscure any copyright,
			                trademark, service mark or other proprietary rights notices
			                incorporated in or accompanying the Website. All trademarks,
			                service marks, logos, trade names, and any other source
			                identifiers of EcoPlug used on or in connection with the
			                Website.. Trademarks, service marks, logos, trade names and any
			                other proprietary designations of third parties used on or in
			                connection with the Website are used for identification purposes
			                only and may be the property of their respective owners.
			              </p>
			            </li>
			            <li>
			              <p>
			                You will not use, copy, adapt, modify, prepare derivative works
			                of, distribute, license, sell, transfer, publicly display,
			                publicly perform, transmit, broadcast or otherwise exploit the
			                Website. No licenses or rights are granted to you by implication
			                or otherwise under any intellectual property rights owned or
			                controlled by Ecoplug or its licensors, except for the licenses
			                and rights expressly granted in these Terms.
			              </p>
			            </li>
			            <li>
			              <p>
			                Ecoplug has tied up with Phonepe/Rozarpe for facilitating the
			                online payment facility available on the Website. Upon making
			                payment on the Website, You shall be bound by the terms and
			                conditions of the payment gateway in addition to the terms
			                stated herein.
			              </p>
			            </li>
			            <li>
			              <p>
			                As a general rule, EcoPlug is not bound to make any refunds for
			                the amount of consideration already paid by you.
			              </p>
			            </li>
			            <li>
			              <p>
			                You as an user, can leave a public review (“Review”) and submit
			                a star rating (“Rating”) about your experience of the Website/
			                and or the Services and/or the Vendors. Ratings and Reviews are
			                not verified by Website for accuracy and may be incorrect or
			                misleading. Ratings and Reviews however must be as accurate and
			                may not contain any offensive or defamatory language.
			              </p>
			            </li>
			            <li>
			              <p>
			                You are solely responsible for compliance with any and all laws,
			                rules, regulations, and tax obligations that may apply to your
			                use of the Website. In connection with your use of the Website,
			                you will not and will not assist or enable others to:
			              </p>
			            </li>
			            <div className="terms-banner--content--list">
			              <ol>
			                <li>
			                  <p>
			                    breach or circumvent any applicable laws or regulations,
			                    agreements with third-parties, third-party rights, or our
			                    Terms and Conditions;
			                  </p>
			                </li>
			                <li>
			                  <p>
			                    use, display, mirror or frame the Website or any individual
			                    element within the Website, EcoPlug's name, any EcoPlug
			                    trademark, logo or other proprietary information, or the
			                    layout and design of any page or form contained on a page on
			                    the Website, without EcoPlug's express written consent;
			                  </p>
			                </li>
			                <li>
			                  <p>
			                    dilute, tarnish or otherwise harm the EcoPlug brand in any
			                    way, including through unauthorized use, registering and/or
			                    using EcoPlug or derivative terms in domain names, trade
			                    names, trademarks or other source identifiers, or
			                    registering and/or using domains names, trade names,
			                    trademarks or other source identifiers that closely imitate
			                    or are confusingly similar to EcoPlug’s domains, trademarks,
			                    taglines, or promotional campaigns;
			                  </p>
			                </li>
			                <li>
			                  <p>
			                    use any robots, spider, crawler, scraper or other automated
			                    means or processes to access, collect data or other content
			                    from or otherwise interact with the Website for any purpose;
			                  </p>
			                </li>
			                <li>
			                  <p>
			                    avoid, bypass, remove, deactivate, impair, descramble, or
			                    otherwise attempt to circumvent any technological measure
			                    implemented by EcoPlug or any of EcoPlug's providers or any
			                    other third party to protect the Website;
			                  </p>
			                </li>
			                <li>
			                  <p>
			                    take any action that damages or adversely affects, or could
			                    damage or adversely affect the performance or proper
			                    functioning of the Website;
			                  </p>
			                </li>
			                <li>
			                  <p>
			                    take any action that damages or adversely affects, or could
			                    damage or adversely affect the performance or proper
			                    functioning of the Website;
			                  </p>
			                </li>
			              </ol>
			            </div>
			            <li>
			              <p>
			                EcoPlug may immediately, without notice, terminate this
			                Agreement and/or stop providing access to the Website if (i) you
			                have materially breached your obligations under these Terms, the
			                payments terms, our Policies, (ii)you have violated applicable
			                laws, regulations or third party rights, or (iii)tatiq believes
			                in good faith that such action is reasonably necessary to
			                protect the personal safety or property of EcoPlug and its
			                Website visitors, its other users and clients.
			              </p>
			            </li>
			            <li>
			              <p>
			                If you choose to use the Website, you do so voluntarily and at
			                your sole risk. The Website is provided “as is”, without
			                warranty of any kind, either express or implied.
			              </p>
			            </li>
			            <li>
			              <p>
			                As a user of the Website, you shall always input true and
			                correct information about yourself. You understand and agree
			                that EcoPlug does not claim any responsibility for the
			                information that is provided by you.
			              </p>
			            </li>
			            <li>
			              <p>
			                The entire responsibility of checking and adhering to the
			                availability of the EV charging stations lies with the User.
			              </p>
			            </li>
			            <li>
			              <p>
			                If we choose to conduct identity verification or background
			                checks on any user, to the extent permitted by applicable law,
			                we disclaim warranties of any kind, either express or implied,
			                that such checks will identify prior misconduct by a guest or
			                guarantee that a guest will not engage in misconduct in the
			                future.
			              </p>
			            </li>
			            <li>
			              <p>
			                You assume full responsibility for the choices you make before,
			                during and after your use of the Website.
			              </p>
			            </li>
			            <li>
			              <p>
			                The foregoing disclaimers apply to the maximum extent permitted
			                by law. You may have other statutory rights. However, the
			                duration of statutorily required warranties, if any, shall be
			                limited to the maximum extent permitted by law.
			              </p>
			            </li>
			            <li>
			              <p>
			                Unless your Country of Residence is in the EU, you acknowledge
			                and agree that, to the maximum extent permitted by law, the
			                entire risk arising out of your access to and use of the
			                Website, and/or use of services via the Website or any other
			                interaction you have with EcoPlug’s personnel whether in person
			                or online remains with you. Neither EcoPlug nor any other party
			                involved in creating, producing, or delivering the Website will
			                be liable for any incidental, special, exemplary or
			                consequential damages, including lost profits, loss of data or
			                loss of goodwill, service interruption, computer damage or
			                system failure or the cost of substitute products or services,
			                or for any damages for personal or bodily injury or emotional
			                distress arising out of or in connection with (i) these Terms,
			                and (ii) from the use of or inability to use the Website. In no
			                event will EcoPlug’s aggregate liability arising out of or in
			                connection with these Terms and your use of the Website
			                including, but not limited to, payment of the charges for the
			                services provided and/or any other applicable charges via the
			                Website, or from the use of or inability to use the Website,
			                exceed the amounts you have paid via the Website.
			              </p>
			            </li>
			            <li>
			              <p>
			                You agree to release, defend (at EcoPlug’s option), indemnify,
			                and hold EcoPlug and its affiliates and subsidiaries, including
			                but not limited to, its officers, directors, employees and
			                agents, harmless from and against any claims, liabilities,
			                damages, losses, and expenses, including, without limitation,
			                reasonable legal fees, arising out of or in any way connected
			                with (i) your breach of these Terms or our Policies, (ii) your
			                improper use of the Website, or (iii) your breach of any laws,
			                regulations or third party rights.
			              </p>
			            </li>
			            <li>
			              <p>
			                You and EcoPlug mutually agree that any dispute, claim or
			                controversy arising out of or relating to these Terms or the
			                breach, termination, enforcement or interpretation thereof, or
			                to the use of the Website, (collectively, “Disputes”) will be
			                settled by arbitration. The Arbitration shall be carried out
			                under the Arbitration and Conciliation Act, 1996 (as applicable
			                in India and as amended from time to time).
			              </p>
			            </li>
			            <li>
			              <p>
			                You and EcoPlug each agree that the following claims are
			                exceptions to the Arbitration Agreement and will be brought in a
			                judicial proceeding in a court of competent jurisdiction: (i)
			                Any claim related to actual or threatened infringement,
			                misappropriation or violation of EcoPlug’s copyrights,
			                trademarks, trade secrets, patents, or other intellectual
			                property rights; (ii) Any claim seeking emergency injunctive
			                relief based on exigent circumstances (e.g., imminent danger or
			                commission of a crime, hacking, cyber-attack).
			              </p>
			            </li>
			            <li>
			              <p>
			                These terms shall be governed by the laws of India, and the
			                courts in New Delhi shall have the exclusive jurisdiction over
			                the matters pertaining to these Terms.
			              </p>
			            </li>
			            <li>
			              <p>
			                We welcome and encourage you to provide feedback, comments and
			                suggestions for improvements to the Website (“Feedback“). You
			                may submit Feedback by emailing us, through the “Contact”
			                section of the Website, or by other means of communication. Any
			                Feedback you submit to us will be considered non-confidential
			                and non-proprietary to you. By submitting Feedback to us, you
			                grant us a non-exclusive, worldwide, royalty-free, irrevocable,
			                sub-licensable, perpetual license to use and publish those ideas
			                and materials for any purpose, without compensation to you.
			              </p>
			            </li>
			            <li>
			              <p>
			                Except as they may be supplemented by additional terms and
			                conditions, policies, guidelines or standards, these Terms
			                constitute the entire Agreement between EcoPlug and you
			                pertaining to the subject matter hereof, and supersede any and
			                all prior oral or written understandings or agreements between
			                EcoPlug and you in relation to the access to and use of the
			                Website.
			              </p>
			            </li>
			            <li>
			              <p>
			                No joint venture, partnership, employment, or agency
			                relationship exists between you and EcoPlug as a result of this
			                Agreement or your use of the Website.
			              </p>
			            </li>
			            <li>
			              <p>
			                These Terms do not and are not intended to confer any rights or
			                remedies upon any person other than the parties.
			              </p>
			            </li>
			            <li>
			              <p>
			                If any provision of these Terms is held to be invalid or
			                unenforceable, such provision will be struck and will not affect
			                the validity and enforceability of the remaining provisions.
			              </p>
			            </li>
			            <li>
			              <p>
			                EcoPlug’s failure to enforce any right or provision in these
			                Terms will not constitute a waiver of such right or provision
			                unless acknowledged and agreed to by us in writing. Except as
			                expressly set forth in these Terms, the exercise by either party
			                of any of its remedies under these Terms will be without
			                prejudice to its other remedies under these Terms or otherwise
			                permitted under law.
			              </p>
			            </li>
			            <li>
			              <p>
			                EcoPlug makes no representation that the Website operates (or is
			                legally permitted to operate) in all geographic areas, or that
			                the Information, Website, or services are appropriate or
			                available for use in other locations. Accessing the Website from
			                territories where the Website or any Information or
			                functionality of the Website or portion thereof is illegal is
			                expressly prohibited. Any access of the Website and the
			                Information thereof by the User from any prohibited jurisdiction
			                is at the entire risk and cost of the User and EcoPlug shall not
			                be responsible for such access. The User shall always be
			                responsible for his own compliance of the applicable laws.
			              </p>
			            </li>
			            <li>
			              <p>Refund Policy</p>
			              <p>
			                We are committed to providing a high-quality service to our
			                customers, and this refund policy outlines the circumstances
			                under which we will issue refunds for charges made through the
			                EcoPlug app. <br />
			              </p>
			              <ol type="a">
			                <li>
			                  <p>Eligibility for Refunds - </p>
			                  <ul>
			                    <p style={{ paddingLeft: 24 }}>
			                      Customers are eligible for a refund in the following
			                      circumstances:
			                    </p>
			                    <li style={{ listStyle: "disc" }}>
			                      <p style={{ marginBottom: 10 }}>
			                        Charges made in error: If you were charged for a
			                        charging session that did not take place, or if the
			                        charging equipment was not functioning properly, you are
			                        eligible for a refund.
			                      </p>
			                    </li>
			                    <li style={{ listStyle: "disc" }}>
			                      <p style={{ marginBottom: 10 }}>
			                        Services not provided as promised: If the charging
			                        station did not provide the level of service that was
			                        promised (e.g., fast charging was not available, the
			                        station was out of service), you are eligible for a
			                        refund.
			                      </p>
			                    </li>
			                    <li style={{ listStyle: "disc" }}>
			                      <p style={{ marginBottom: 10 }}>
			                        Unsatisfactory service: If you are unhappy with the
			                        service provided by the charging station or the EcoPlug
			                        app, and you believe that a refund is warranted, you may
			                        be eligible for a refund.
			                      </p>
			                    </li>
			                  </ul>
			                </li>
			                <li>
			                  <p>Requesting a Refund - </p>
			                  <p>
			                    To request a refund, please contact the EcoPlug customer
			                    service team by emailing ecoplugcharge@gmail.com or by
			                    calling 9119115675. Please  include your name, email
			                    address, phone number, and a detailed description of the
			                    issue that you experienced. Our customer service team will
			                    review your request and determine whether a refund is
			                    warranted.
			                  </p>
			                </li>
			                <li>
			                  <p>Processing of Refunds - </p>
			                  <p>
			                    If your refund request is approved, the refund will be
			                    processed within 9 business days. The refund will be
			                    credited back to your EcoPlug account, or refunded to the
			                    payment method that was used to make the original charge.
			                  </p>
			                </li>
			                <li>
			                  <p>Limitations - </p>
			                  <p>
			                    There are a few circumstances under which we are unable to
			                    issue refunds:
			                  </p>
			                  <ul>
			                    <li style={{ listStyle: "disc" }}>
			                      <p style={{ marginBottom: 10 }}>
			                        If you have used the charging service for an extended
			                        period of time, we may not be able to issue a full
			                        refund. In these cases, we will issue a partial refund
			                        based on the amount of time that you used the service.
			                      </p>
			                    </li>
			                    <li style={{ listStyle: "disc" }}>
			                      <p style={{ marginBottom: 10 }}>
			                        If the issue that you experienced was not the result of
			                        an error on our part, or if the charging station was
			                        functioning properly, we may not be able to issue a
			                        refund.
			                      </p>
			                    </li>
			                  </ul>
			                </li>
			                <li>
			                  <p>Changes to the Refund Policy</p>
			                  <p>
			                    We reserve the right to update this refund policy at any
			                    time. If we make any changes to the policy, we will post the
			                    updated policy on this page and update the "Last Updated"
			                    date at the top of the page. We encourage you to review the
			                    policy periodically to stay informed about our policies and
			                    practices.
			                  </p>
			                </li>
			              </ol>
			              <p />
			            </li>
			            <li>
			              <p>
			                If you have any questions about these Terms please email us at
			                <a href="mailto:ecoplugcharge@gmail.com">
			                  ecoplugcharge@gmail.com.
			                </a>
			              </p>
			            </li>
			          </ol>
			        </div>
			      </div>
			    </div>
			  </section>
			</div>


	)
}

export default Privacy;